import { supabase } from '../lib/supabase'
import type { InboxItemType } from '../types/inbox'

export interface InboxAssignmentHistoryRow {
  id: string
  item_type: InboxItemType
  item_id: string
  assigned_to_user_id: string | null
  assigned_by_user_id: string | null
  created_at: string
}

export async function fetchInboxAssignmentHistory(
  itemType: InboxItemType,
  itemId: string,
  limit = 20
): Promise<InboxAssignmentHistoryRow[]> {
  const { data, error } = await supabase
    .from('inbox_assignment_history')
    .select('id, item_type, item_id, assigned_to_user_id, assigned_by_user_id, created_at')
    .eq('item_type', itemType)
    .eq('item_id', itemId)
    .order('created_at', { ascending: false })
    .limit(limit)
  if (error) throw error
  return (data || []) as InboxAssignmentHistoryRow[]
}